import {useUserTokenOrSessionId} from '@aboutyou/user';
import {useEffect} from 'react';
import {useBrowserSpecificUUID} from '../../../features/BrowserSpecificUUID/useBrowserSpecificUUID';
import {DevicePushState} from '../../../features/useDevicePushState/enums/DevicePushState';
import {useDevicePushState} from '../../../features/useDevicePushState/useDevicePushState';
import {getUserPermissionsAndFirebaseToken} from '../getUserPermissionsAndFirebaseToken';

export const useNotifyBackendInCaseNotHappened = (
  updatePushNotification: (newState: DevicePushState, token?: string) => void,
) => {
  const {updateDevicePushState} = useDevicePushState();
  const uuid = useBrowserSpecificUUID();
  const {data: tokenOrSessionId, isLoading} = useUserTokenOrSessionId();
  useEffect(() => {
    const newState = updateDevicePushState();
    if (uuid && isLoading === false && tokenOrSessionId !== null) {
      if (newState === DevicePushState.SENT) {
        getUserPermissionsAndFirebaseToken().then(token => {
          // eslint-disable-next-line local-rules/set-state-in-use-effect -- TODO: Cleanup setState in useEffect https://aboutyou.atlassian.net/browse/ASFE-7602
          updatePushNotification(newState, token);
        });
      } else {
        updatePushNotification(newState);
      }
    }
  }, [uuid, isLoading]);
};
